<template>
  <div class="asc-navbar-button">
    <v-badge :value="isBadge" overlap>
      <template #badge>
        <span>{{ getCount }}</span>
      </template>
      <v-menu v-model="showMenu" offset-y left close-on-click>
        <template #activator="{ on }">
          <v-btn
            fab
            x-small
            :class="['ma-0', showMenu ? 'asc-navbar-button--active' : null]"
            v-on="on"
          >
            <template v-if="!isText">
              <v-icon :size="14">{{ icon }}</v-icon>
            </template>
            <template v-if="isText">
              <span class="asc-navbar-button--text">{{ text }}</span>
            </template>
          </v-btn>
        </template>
        <asc-menu-list
          :primary-items="primaryItems"
          :secondary-items="secondaryItems"
          :width="width"
          dense
        ></asc-menu-list>
      </v-menu>
    </v-badge>
  </div>
</template>

<script>
import AscMenuList from './AscMenuList'

export default {
  name: 'AscNavbarButton',

  components: {
    AscMenuList,
  },

  props: {
    icon: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
      default: 0,
    },
    primaryItems: {
      type: Array,
      default: () => [],
    },
    secondaryItems: {
      type: Array,
      default: () => [],
    },
    width: {
      type: Number,
      default: 250,
    },
  },

  data() {
    return {
      showMenu: false,
    }
  },

  computed: {
    isText() {
      return this.text.length > 0
    },
    isBadge() {
      return !!(this.count && this.count > 0)
    },
    getCount() {
      return this.isBadge && this.count < 10 ? this.count : ''
    },
  },
}
</script>

<style lang="scss">
.asc-navbar-button {
  .v-btn--floating {
    height: 32px;
    width: 32px;
  }

  .theme--light.v-btn:not(.v-btn--icon):not(.v-btn--text) {
    background-color: $gray-300;
    box-shadow: none;

    .v-icon {
      color: $primary-black;
    }

    &:hover {
      background-color: $gray-900;

      span {
        color: $primary-white !important;
      }

      .v-icon {
        color: $primary-white !important;
      }
    }
  }

  .v-badge__badge {
    position: absolute;
    font-size: 12px;
    height: 16px;
    width: 16px;
  }

  .v-badge--overlap .v-badge__badge {
    right: -4px;
    top: -6px;
    background-color: $badge-red !important;
  }

  &--text {
    font-size: 14px;
  }

  .asc-navbar-button--active {
    background-color: $gray-900 !important;

    span {
      color: $primary-white !important;
    }

    .v-icon {
      color: $primary-white !important;
    }
  }
}
</style>
